export const state = {
    articles: []
}